import React, { Component } from 'react';
import './Collage.css';
import { Image, Picture } from 'pixboost-react';
import pixboostConfig from '../../../config/pixboost';
import Cta from '../Cta/Cta';
import classNames from 'classnames';

class Collage extends Component {
  render() {
    const {
      title,
      image,
      link,
      links,
      backgroundColour,
      buttonText,
      ctaPosition,
      ctaMobilePosition,
      isResponsiveImage,
      description,
      titleFontSize,
      linkTag
    } = this.props.contentBlock;

    const { className } = this.props;
    const { imageBasePath } = this.props.storeConfig;

    const classes = classNames(className, {
      [backgroundColour]: backgroundColour
    });
    if (!this.props.contentBlock || !this.props.storeConfig) {
      return null;
    }
    return (
      <div>
        <div className={classes} title={title}>
          <div>
            <Cta
              title={title}
              buttonText={buttonText}
              ctaPosition={ctaPosition}
              ctaMobilePosition={ctaMobilePosition}
              link={link}
              description={description}
              titleFontSize={titleFontSize}
              links={links}
              linkTag={linkTag}
            />
          </div>
          {image && (
            <div>
              <div className="image">
                {isResponsiveImage ? (
                  <Picture
                    alt={title}
                    breakpoints={{
                      lg: {
                        src: imageBasePath + image.lg
                      },
                      md: {
                        src: imageBasePath + image.md
                      },
                      sm: {
                        src: imageBasePath + image.sm
                      }
                    }}
                    config={pixboostConfig}
                    lazy={false}
                  />
                ) : (
                  <Image
                    src={imageBasePath + image}
                    alt={title}
                    config={pixboostConfig}
                    lazy={false}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Collage;



// WEBPACK FOOTER //
// ./src/components/content-blocks/Collage/Collage.js